import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AttachmentsService } from 'src/app/attachments/attachments.service';
import { EntitiesService } from 'src/app/configuration/entities.service';
import { MailAccountsService } from 'src/app/configuration/mail-accounts/mail-accounts.service';
import { TemplatesService } from 'src/app/configuration/templates/templates.service';
import { SearchService } from 'src/app/core/search.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { ContactsService } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/contacts.service';
import { ReportsService } from 'src/app/reports/reports.service';
import { UserMailAccountsService } from 'src/app/users/users-mail-accounts-detail/user-mail-accounts.service';
import { UsersService } from 'src/app/users/users.service';
import { TemplatesTypesService } from '../../configuration/templates/templates-types.service';
import { NotificationsService } from '../../notifications/notifications.service';
import { UsersDetailComponent } from '../../users/users-detail/users-detail.component';
import { MailingAttachmentsComponent } from '../mailing-attachments/mailing-attachments.component';
import { MailingToDetailComponent } from '../mailing-to-detail/mailing-to-detail.component';
import { UsersSearcherComponent } from '../users-searcher/users-searcher.component';
import { OrganizationsService } from 'src/app/organizations/organizations.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';

@Component({
  selector: 'app-mailing-detail',
  templateUrl: './mailing-detail.component.html',
  styleUrls: ['./mailing-detail.component.scss']
})
export class MailingDetailComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public searchResults: any[] = [];
  public searchText: any;
  public searchResultsBCC: any[] = [];
  public searchTextBCC: any;
  public attachment: any = {};
  public meeting_users;
  public entities_ids: any[] = [];
  public total_tos: number = 0;
  public firstLoad: boolean = true;
  public allNotificationsAssigned: boolean = false;
  public notificationsToManaged: number = 0;
  public searchTextOrg: string = "";

  public emails: any = [];
  public showCCCblock: boolean = false;
  public email = {
    from: null,
    date: null,
    to: [],
    ccc: [],
    bcc: [],
    tos: "",
    cccs: "",
    bccs: "",
    subject: "",
    template_id: null,
    body: "",
    files: [],
    entity_id: null,
    entity_pk_id: null,
    organization_id: null,
    contact_id: null,
    toInfo: [],
    status: "",
    type: ""
  }
  public mail_id;
  public mail_account_id;
  public template_type_id;
  public notification_to_id;
  public templates: any[] = [];
  public disableFields: boolean = false;
  public errorText: string = null;
  public notificationsTo: any[] = [];
  public statusOptions = [
    //{"state":"Todos", "value":null},
    { "state": "Enviado", "value": "sent" },
    { "state": "Pendiente", "value": "pending" },
    { "state": "Programado", "value": "programmed" },
    { "state": "Error", "value": "error" },
  ]

  public organizations: any[] = [];
  public contacts: any[] = [];
  public notificationsToFilters: any = {};
  public countSentsMessages: number;
  private is_generic: boolean = null;
  public templateTypes: any[];
  public resendMail: boolean = false;
  private emailsSignature: string = "";

  constructor(
    private entitiesService: EntitiesService,
    private templatesService: TemplatesService,
    private mailAccountsService: MailAccountsService,
    private searchService: SearchService,
    private userMailAccountsService: UserMailAccountsService,
    private notificationsService: NotificationsService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private organizationsService: OrganizationsService,
    private attachmentsService: AttachmentsService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private reportsService: ReportsService,
    private dialogService: DialogService,
    public sanitizer: DomSanitizer,
    public viewsService: ViewsService,
    public templateTypesService: TemplatesTypesService,
    public coreDialogService: CoreDialogService,
  ) {
    this.resendMail = this.config.data.resendMail;
    console.log(this.config.data);

  }

  ngOnInit(): void {
    this.usersService.getUsersSignatureEmail(parseInt(localStorage.getItem("userId"))).subscribe(
      (userHtml: any) => {
        //console.log(userHtml);
        this.email.body = userHtml.emailsSignature;
        this.emailsSignature = userHtml.emailsSignature;
      }
    );

    this.templateTypesService.all({}).subscribe(
      data => {
        this.templateTypes = data.rows;

        this.mail_account_id = this.config.data.mail_account_id;
        this.mail_id = this.config.data.mail_id;
        if (this.mail_id) this.loadNotificationsTo();
        this.email.entity_id = this.config.data.entity_id
        this.email.entity_pk_id = this.config.data.entity_pk_id;


        if (typeof (this.config.data.template_type_code) !== "undefined") {
          this.template_type_id = this.templateTypes.filter(m => m.code == this.config.data.template_type_code)[0].id;
        } else {
          this.template_type_id = this.config.data.template_type_id;
        }

        this.meeting_users = this.config.data.meeting_users;
        this.notification_to_id = this.config.data.notification_to_id;
        this.is_generic = this.config.data.is_generic;
       
        if (this.mail_id == null) {
          this.loadEmails();
          if (this.template_type_id == null) {
            this.template_type_id = 1;
          }
          if (this.config.data.to != null) {
            if (typeof this.config.data.to == "string") {
              this.email.to = [{ email: this.config.data.to }];
            } else {
              //Ha mandado un objecto
              if (this.config.data.to.email) this.email.to = [this.config.data.to];
            }
            this.email.toInfo.push(this.config.data.to);
          }
          if (this.meeting_users != null && this.meeting_users.length > 0) {
            this.meeting_users.forEach(external_user => {
              this.email.to.push({ email: external_user.email });
              this.email.toInfo.push(external_user);
            });
          }
          this.email.tos = String(this.email.to.map(function (item) {
            return item['email'];
          }));
          if (this.mail_account_id) {
            this.email.from = this.mail_account_id;
          }
          if (this.config.data.organization_id != null) this.email.organization_id = this.config.data.organization_id;
          if (this.config.data.contact_id != null) this.email.contact_id = this.config.data.contact_id;
        } else {
          this.loadEmail();
          this.loadToInformation();
          this.loadMailingAttachments();
          //this.disableFields = true;
        }
        //Se buscan las entidades relacionadas siempre salvo cuando sean internas. Por eso se pasa el searchRelated.
        //console.log(this.config.data);
        if (typeof (this.config.data.searchRelated) === "undefined") this.config.data.searchRelated = true;
        if (this.email.entity_id != null && this.config.data.searchRelated) this.loadRelatedEntities();
        if (!this.config.data.searchRelated) this.loadTemplates();
      }, error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );

  }

  loadEmail() {
    this.userMailAccountsService.all({ user_id: localStorage.getItem("userId") }).subscribe(
      dataMail => {
        this.emails = dataMail.rows;

       
      this.notificationsService.get(this.mail_id).subscribe(
        data => {

          if (this.emails.length > 0) {
         
            var aux = this.emails.filter(m => m.mailAccount_id == data["mail_account_id"]);
            if (aux.length > 0) {
              //hemos encontrado el email desde el que se le ha enviado.
              this.email.from = aux[0].mailAccount.name;
            }
          } 

          this.email.body = "<br><br><br>" + this.emailsSignature + "<br><br>----------------------------------------------------------<br>El " + new Date(data["date"]).toLocaleString() + "  " + data["from"] + " escribió:<br><br>" + data["content"];
          this.email.subject = "RE: " + data["subject"];
          this.email.bcc = data["bcc"];
          this.email.date = data["date"];
          this.email.type = data["type"];
          this.email.status = data["status"];
          this.email.entity_id = data["entity_id"];

          this.loadMailTos(data["id"]);
        },
        error => {

        });
        console.log(this.emails);
        //Eliminado por defecto mostrar el email del usuario logueado... lo ha pedido el 03/11/2022
        //this.emails.unshift({ mailAccount: { name: localStorage.getItem("email") } });
        //console.log(this.email.from, data.rows);

        if (this.email.from == null && this.emails.lenght > 0) {
          this.email.from = this.emails[0].mailAccount.name;
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  getUrl(guid) {
    let notificationTo = this.notification_to_id;
    if (typeof (notificationTo) == "undefined") notificationTo = "";
    var url = "https://app.axialcrm.com/api/PublicAttachments/" + localStorage.getItem("companyId") + "/" + guid + "/" + notificationTo + "/download";
    return url
  }

  getUrlIcon(mimetype) {
    var srcImage = "https://app.axialcrm.com/assets/img/mimes/";
    var ret = "other.png";
    if (mimetype == "application/pdf") {
      ret = "pdf.png";
    } else if (mimetype == "image/png" || mimetype == "image/jpeg" || mimetype == "image/jpg" || mimetype == "image/gif" || mimetype == "image/bmp") {
      ret = "img.png";
    } else if (mimetype == "application/msword" || mimetype == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      ret = "word.png";
    } else if (mimetype == "application/vnd.ms-excel" || mimetype == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      ret = "xls.png";
    } else if (mimetype == "application/vnd.ms-powerpoint" || mimetype == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
      ret = "pwt.png";
    }
    return srcImage + ret;
  }

  loadNotificationsTo() {
    var params = { notification_email_id: this.mail_id }
    params = Object.assign(params, this.notificationsToFilters);

    this.notificationsService.allNotificationsTo(params).subscribe(
      data => {
        this.notificationsTo = data.rows;
        if (this.email.type == "in") this.searchOrganizations();

        if (data.totalRows > 0) {
          var aux = this.notificationsTo.filter(m => m.recipient_type == "to");
          this.email.entity_pk_id = aux[0]["entity_pk_id"];
          this.email.contact_id = aux[0]["contact_id"];
          this.email.organization_id = aux[0]["organization_id"];
        }
        if (this.firstLoad) {
          this.countSentsMessages = this.notificationsTo.filter(nt => (nt.state == "sent" || nt.state == "discarded")).length;
          this.total_tos = this.notificationsTo.length;
        }
        this.firstLoad = false;
        this.countNotificationsToManaged();
      },
      error => {

      }
    );
  }

  loadToInformation() {
    if (this.notification_to_id) {
      console.log("loadToInformation", this.notification_to_id);
      this.notificationsService.getNotificationTo(this.notification_to_id).subscribe({
        next: (data: any) => {
          this.errorText = data.text;
        },
        error: (error: any) => {
          console.log(error);
          }
      });
    }
  }
  loadMailingAttachments() {
    this.attachmentsService.all({ mail_id: this.mail_id }).subscribe(
      data => {
        this.email.files = data.rows;
      },
      error => {

      }
    );
  }

  loadMailTos(notification_email_id) {
    this.notificationsService.allNotificationsTo({ notification_email_id: notification_email_id }).subscribe(
      data => {
        this.email.to = data.rows.filter(m => m.recipient_type == "to").map(m => ({ "email": m.mails }));
        this.email.bcc = data.rows.filter(m => m.recipient_type == "bcc").map(m => ({ "email": m.mails }));
        this.email.ccc = data.rows.filter(m => m.recipient_type == "cc").map(m => ({ "email": m.mails }));
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  loadRelatedEntities() {
    this.entitiesService.getRelatedEntities(this.config.data.entity_id).subscribe(
      (data: any) => {
        this.entities_ids = data;
        this.loadTemplates();
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  loadTemplates() {
    if (this.email.entity_id && this.template_type_id) {
      this.templatesService.all({ template_type_id: this.template_type_id, entity_id: this.email.entity_id, related_entities_ids: this.entities_ids }).subscribe(
        data => {
          this.templates = data.rows;
          //Si es un mail interno, que se carga la primera plantilla por defecto y se añade la opción 'ninguna' al final.
          if (this.config.data.template_type_code == "MAIL_INTERNAL") {
            if (this.templates.length > 0) {
              this.email.template_id = this.templates[0].id
              this.loadTemplateValue({ value: this.email.template_id });
            }
          }
          this.templates.unshift({ name: "Ninguna" });


        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  loadContacts(notificationTo) {
    this.contactsService.all({ _sortBy: "fullname", _sortDirection: "asc", organization_id: notificationTo.organization_id }).subscribe(
      data => {
        this.contacts[notificationTo.id] = data.rows;
      }, error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  loadOrganizations() {
    this.organizationsService.all({ _sortBy: "name", _sortDirection: "asc" }).subscribe(
      data => {
        this.organizations = data.rows;
      }, error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );

  }

  searchOrganizations() {
    let params:any = {
      searchText: this.searchTextOrg
    };
    if (this.notificationsTo != null) params.include_organization_id = this.notificationsTo.filter(m=>m.organization_id != null).map(m => m.organization_id);
    this.organizationsService.getCombo(params).subscribe(
      data => {
        this.organizations = data.rows;

        if (this.email.type == 'in') {
          this.notificationsTo.forEach(notificationTo => {
            if (notificationTo.organization_id!=null) this.loadContacts(notificationTo);
          });
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  loadTemplateValue(event) {
    //console.log("loadTemplateValue");
    //Esto carga el HTML de la plantilla en el editor:
    if (event.value) {
      this.templatesService.get(event.value).subscribe(
        data => {
          this.email.body = data.html;
          var template = {
            name: "blank",
            html: "blank",
            subject: data.subject
          }
          /* TODO: Traer en el this.config el entity_id y el entity_id_pk y pasárselos a la siguiente función.*/
          this.templatesService.toHTML(event.value, this.email.entity_id, this.email.entity_pk_id, template).subscribe(
            data => {
              //var html = this.preserveTextFormat(data.html);
              this.email.body = data.html;
              //Si el asunto está vacío, cambia su valor por el título de la plantilla:
              if (this.email.subject == null || this.email.subject == "" || this.email.subject.length == 0) {
                this.email.subject = data.subject;
              }
              //this.res = this.sanitizer.sanitize(SecurityContext.HTML,data.html);
            },
            error => {
              this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
            }
          );
        }
      );
    } else {
      this.email.body = "";
    }
  }

  preserveTextFormat(text) {
    text = text.replace('<span >', '<span>');
    // Reemplazar las tabulaciones con la entidad &emsp;
    text = text.replace(/\t/g, '&emsp;');
    // Reemplazar los saltos de línea con la etiqueta <br>
    text = text.replace(/\n/g, '<br>');
    // Reemplazar los espacios en blanco con la entidad &nbsp;
    text = text.replace(/\s/g, '&nbsp;');
    return text;
  }

  loadEmails() {
    this.userMailAccountsService.all({ user_id: localStorage.getItem("userId") }).subscribe(
      data => {
        this.emails = data.rows;

        console.log(this.emails);
        //Eliminado por defecto mostrar el email del usuario logueado... lo ha pedido el 03/11/2022
        //this.emails.unshift({ mailAccount: { name: localStorage.getItem("email") } });
        //console.log(this.email.from, data.rows);

        if (this.email.from == null && this.emails.lenght > 0) {
          this.email.from = this.emails[0].mailAccount.name;
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
  }

  sendEmail() {
    if (this.email.tos != null && this.email.tos.length != 0) {
      this.email.tos = String(this.email.to?.map(function (item) {
        return item['email'];
      }));
    }

    if (this.email.bcc != null && this.email.bcc.length != 0) {
      this.email.bccs = String(this.email.bcc?.map(function (item) {
        return item['email'];
      }));
    }

    if (this.email.ccc != null && this.email.ccc.length != 0) {
      this.email.cccs = String(this.email.ccc?.map(function (item) {
        return item['email'];
      }));
    }

    //console.log(this.email);
    this.reportsService.sendEmail(this.email).subscribe(
      res => {
        this.messageService.add({ closable: false, severity: 'success', summary: 'Enviando email' });
        this.dynamicDialogRef.close("success");
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
    // this.mailAccountsService.send(this.email.from, this.email).subscribe(
    //   data => {
    //     this.messageService.add({ closable: false, severity: "success", detail: "Email enviado correctamente" });
    //   },
    //   error => {
    //     /*if(this.email.from)*/ this.messageService.add({ closable: false, severity: "error", detail: "No está configurada la cuenta de correo seleccionada para poder mandar emails desde la herramienta." });
    //     //if(!this.email.from) this.messageService.add({ closable: false, severity: "error", detail: "No hay una cuenta de correo seleccionada."});
    //   }
    // )
  }

  filterSearch(event) {
    let filtered: any[] = [];
    let query = event.query;
    if (query.length >= 4) {
      filtered.push(
        {
          email: query
        }
      );
      this.searchService.onlyPeople({ email: query }).subscribe(
        data => {
          data.forEach(element => {
            filtered.push(element);
          });
          this.searchResults = filtered;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
        }
      );
    }
  }
  onErrorUpload(event) {
    this.messageService.add({ closable: false, severity: 'error', detail: "Error subiendo archivo" });
  }
  onBasicUpload(event) {
    //console.log(event);
    let i = 0;
    let guids = [];
    if (event.files.length > 1) guids = event.originalEvent.body.guids;
    else if (event.files.length == 1) guids = [event.originalEvent.body.guid];
    for (let f of event.files) {
      var file = { filename: "", mimetype: "", guid: "", size: "" };
      file.filename = f.name;
      file.mimetype = f.type;
      file.guid = guids[i];
      file.size = f.size;
      this.email.files.push(file);
      i++;
    }
    /* if (event.originalEvent.body.off) {
       var guidNum = 0;
       event.originalEvent.body.files.forEach(file => {
         var datafile = {
           description: file.fileName,
           filename: file.fileName,
           mimetype: file.contentType,
           size: file.length,
           guid: event.originalEvent.body.guids[guidNum],
           entity_id: this.config.data.entity_id,
           entity_pk_id: this.config.data.entity_pk_id,
           organization_id: this.config.data.organization_id,
           //TODO: ¿Darle un valor a attachment_type_id?:
           //attachment_type_id: this.attachment.attachment_type_id
         };
         this.attachmentsService.add(datafile).subscribe(
           data => {
           },
           error => {
             this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
           }
         );
         guidNum = guidNum + 1;
       });
     } else {
       this.attachment.description = event.originalEvent.body.filename;
       this.attachment.filename = event.originalEvent.body.filename;
       this.attachment.mimetype = event.originalEvent.body.mimetype;
       this.attachment.size = event.originalEvent.body.size;
       this.attachment.guid = event.originalEvent.body.guid;
       this.attachment.entity_id = this.config.data.entity_id;
       this.attachment.entity_pk_id = this.config.data.entity_id_pk;
       this.attachment.organization_id = this.config.data.organization_id;
       this.attachmentsService.add(this.attachment).subscribe(
         data => {
         },
         error => {
           this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
         }
       );
     }*/
  }

  deleteAttachment(guid, index) {
    this.email.files.splice(index, 1);
  }

  changeCCCblock() {
    this.showCCCblock = !this.showCCCblock;
  }

  uploadAxial() {
    //console.log("uploadAxial", this.is_generic);
    const ref = this.dialogService.open(MailingAttachmentsComponent, {
      data: {
        entity_id: this.email.entity_id,
        entity_pk_id: this.email.entity_pk_id,
        organization_id: this.email.organization_id,
        is_generic: this.is_generic
      },
      header: "Adjuntar documentos de Axial",
      width: "50%",
      /*baseZIndex: 1000*/
    });
    ref.onClose.subscribe((data: any) => {
      //if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      if (data != null) {
        for (let f of data) {
          this.email.files.push(f);
        }
      }
    });
  }

  viewInfo(notificationTo) {
    const ref = this.dialogService.open(MailingToDetailComponent, {
      data: {
        notification_to_id: notificationTo.id,
        //organization_id: this.organization.id,
      },
      header: "Más información",
      width: '900px',
    });
  }

  clearFilters() {
    this.notificationsToFilters = {};
    this.search();
  }

  search() {
    this.loadNotificationsTo();
  }

  getState(status) {
    if (status == 'sent') {
      return "<div class='badge badge-block badge-success'>Enviado</div>";
    } else if (status == "pending") {
      return "<div class='badge badge-block badge-warning'>Pendiente</div>";
    } else if (status == "programmed") {
      return "<div class='badge badge-block badge-info'>Programado</div>";
    } else if (status == "error") {
      return "<div class='badge badge-block badge-danger'>Error</div>";
    } else if (status == "discarded") {
      return "<div class='badge badge-block badge-info'>Descartado</div>";
    } else {
      return "<div class='badge badge-block badge-secondary'>Pendientes</div>";
    }

  }

  openEditUser() {
    const ref = this.dialogService.open(UsersDetailComponent, {
      data: {
        id: parseInt(localStorage.getItem("userId"))
      },
      //header: "Detalles del usuario",
      width: '70%',
    });
    ref.onClose.subscribe((data) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.loadEmails();
    });
  }


  getImage(mimetype) {
    var ret = "other.png";
    if (mimetype == "application/pdf") {
      ret = "pdf.png";
    } else if (mimetype == "image/png" || mimetype == "image/jpeg" || mimetype == "image/jpg" || mimetype == "image/gif" || mimetype == "image/bmp") {
      ret = "img.png";
    } else if (mimetype == "application/msword" || mimetype == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      ret = "word.png";
    } else if (mimetype == "application/vnd.ms-excel" || mimetype == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      ret = "xls.png";
    } else if (mimetype == "application/vnd.ms-powerpoint" || mimetype == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
      ret = "pwt.png";
    }
    return ret;
  }

  openUsersSearcher(destiny) {
    const ref = this.dialogService.open(UsersSearcherComponent, {
      data: {
        emails: this.email.to,
        organizationId: this.email.organization_id,
        destiny: destiny,
        viewAll: true
      },
      header: "Buscar emails",
      width: '35%',
    });
    ref.onClose.subscribe((data: any) => {
      if (data != null) {
        this.usersSearcherResults(data.emails, data.destiny);
      } else {

      }
    });
  }

  usersSearcherResults(results, destiny) {
    var temp_emails = results;/*.map((email) => {
      return { name: name, email: email }
    });*/

    if (destiny == 'to') {
      var finalMails: any[] = [];
      this.email.to.forEach(email => { finalMails.push(email); });
      temp_emails.forEach(email => { finalMails.push(email); });
      this.email.to = finalMails;
    } else if (destiny == 'ccc') {
      var finalMails: any[] = [];
      this.email.ccc.forEach(email => { finalMails.push(email); });
      temp_emails.forEach(email => { finalMails.push(email); });
      this.email.ccc = finalMails;
    } else if (destiny == 'bcc') {
      var finalMails: any[] = [];
      this.email.bcc.forEach(email => { finalMails.push(email); });
      temp_emails.forEach(email => { finalMails.push(email); });
      this.email.bcc = finalMails;
    }

    if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
    /*
    this.email.to = this.email.to.filter(this.onlyUnique);
    this.email.ccc = this.email.ccc.filter(this.onlyUnique);
    this.email.bcc = this.email.bcc.filter(this.onlyUnique);
    */
  }
  onlyUnique(value, index, self) {
    //Realiza la función de un distinct.
    return self.indexOf(value) === index;
  }
  onStateChange($event) {
    if ($event.value == null) delete this.notificationsToFilters.state;
    this.search();
  }
  discardNotificationTo(notificationTo) {
    this.coreDialogService.confirm({
      message: '¿Quieres descartar el email para "' + notificationTo.mails + '"?',
      accept: () => {
        notificationTo.state = "discarded";
        //notificationTo.deleted = true;
        //this.saveNotificationTo(notificationTo);
        this.countNotificationsToManaged();
      },
      reject: () => {

      }
    });

  }
  onChangeOrganization(notificationTo, $event) {
    delete notificationTo.contact_id;
    if (notificationTo.organization_id != null) {
      notificationTo.state = "assigned";
      this.loadContacts(notificationTo);
      //this.saveNotificationTo(notificationTo);
    } else {
      notificationTo.state = "pending_assign";
    }
    this.countNotificationsToManaged();
  }
  onChangeContact(notificationTo) {
    if (notificationTo.organization_id != null && notificationTo.contact_id != null) {
      //this.saveNotificationTo(notificationTo);
    }
  }

  onOrganizationFilter($event) {
    this.searchTextOrg = $event.filter;
    if (this.searchTextOrg.length > 1) this.searchOrganizations();
    else if (this.searchTextOrg.length == 0) {
      this.searchOrganizations();
    }
  }

  saveNotificationsTo() {
    this.notificationsTo.forEach(not => {
      not.notificationEmails = null;
      not.organization = null;
    });
    this.notificationsService.saveNotificationsTo(this.mail_id, this.notificationsTo).subscribe(
      data => {
        this.messageService.add({ severity: 'success', summary: 'Correos asignados correctamente' });
        this.dynamicDialogRef.close();
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }
  countNotificationsToManaged() {
    //Se encarga de comprobar si todos los Notifications To han sido gestionados (asignados o descartados).
    this.notificationsToManaged = this.notificationsTo.filter(m => m.state == 'assigned' || m.state == 'discarded').length;
    this.allNotificationsAssigned = (this.notificationsToManaged == this.total_tos);
  }

  assign() {
    if (!this.allNotificationsAssigned) return;
    //Para entrar en este método, todos los notifications_to deberían estar en estado 'assigned' y/o 'discarded' (gestionados) para poder guardar cambios.
    this.saveNotificationsTo();
  }
}
